import { Input } from "Components/Input";
import {useTranslation} from "react-i18next";
import React, {useEffect, useMemo, useState} from "react";
import {IQueryParam} from "../../../Apis/Models/IQueryParams";
import Label from "../../../Components/Label";
import Select from "../../../Components/Select";
import useFilteredList from "../../../Hooks/UseFilteredList";

interface Fields {
    [key: string]: IQueryParam;
}
interface IProps {
    filterUpdated: (params: Fields, resetParams: boolean) => void;
    currentValue: Fields;
}
const InventoryListFilter = (props: IProps) => {

    const { t } = useTranslation();

    const { filterUpdated, currentValue } = props;

    const [ query, setQuery ] = useState<Fields>(currentValue);

    const listStatus = useMemo(() => [
        { value: undefined,label: t('designListed.all')},
        { value: "false" ,label: t('designListed.unlisted')},
        { value: "true",label: t('designListed.listed')},
    ], [t]);

    const [ filteredListedStatus, setFilteredListedStatus ] = useFilteredList(listStatus, x => [x.label]);

    useEffect(() => {
        setQuery(currentValue);
    }, [currentValue]);

    const setQueryField = (fieldName: 'search' | 'listed', value: IQueryParam) => {
        const newValue = {...query, [fieldName]: value }
        setQuery(newValue);
        filterUpdated(newValue, true);
    }

    return (
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 20}}>
            <Input name={"search"} value={query['search'] ?? ''} onChange={value => setQueryField('search', value)} placeholder={t('search')} />

            <div>
                <Label placeholder={t('Status')} />
                <Select name={"Listed"} value={query['listed']} onChange={value => setQueryField('listed', value)} onFilter={setFilteredListedStatus}>
                    {filteredListedStatus?.map((status, index) => <Select.Option key={index} value={status.value} label={status.label} />)}
                </Select>
            </div>
        </div>
    )

}

export default InventoryListFilter